import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener, Input, SimpleChanges } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { AppUtils } from '../../common/utility/appUtil';
import { DashboardLocalService } from "../../services/dashboard/dashboard-local.service";
import { FadingDialogComponent } from '../../dashboard/fading-dialog/fading-dialog.component';
import $ from 'jquery';
import { UserDataService } from '../../services/user-data.service';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';

import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import ExportData from 'highcharts/modules/export-data';
import StockModule from 'highcharts/modules/stock';
import { Dropdown } from 'primeng/dropdown';

function applyHighchartsModule(module, Highcharts) {
  if (typeof module === 'function') {
    module(Highcharts);
  } else if (module && typeof module.default === 'function') {
    module.default(Highcharts);
  }
}

applyHighchartsModule(Exporting, Highcharts);
applyHighchartsModule(OfflineExporting, Highcharts);
applyHighchartsModule(ExportData, Highcharts);
applyHighchartsModule(StockModule, Highcharts);

@Component({
  selector: 'app-inquiries-by-trend',
  templateUrl: './inquiries-by-trend.component.html',
  styleUrls: ['./inquiries-by-trend.component.scss']
})
export class InquiriesByTrendComponent implements OnInit, AfterViewInit {
  @ViewChild('inqByTrendDropdownRef') dropdown!: Dropdown;
  ngAfterViewInit(): void {
    /* this.cdr.detach(); */
  }
  
  constructor(
    private dashboardService: DashboardService, 
    private userDataService: UserDataService, 
    private localService: DashboardLocalService, 
    private cdr: ChangeDetectorRef
  ) {
    this.drilldownOn = false;
    this.inquiriesByTrend.ngComponent = this;
  }
  closeDropdownProgrammatically() {
    if (this.dropdown.overlayVisible) {
      this.dropdown.hide();  // <-- this closes the dropdown
    }
  }
  
  rootNode: any;
  HighCharts = Highcharts; // required
  @Input() trendData: any;
  
  // Reference to component for tooltip click handler
  private static activeComponent: InquiriesByTrendComponent;
  
  // Global tooltip click handler function
  handleTooltipClick = (e) => {
    console.log('Tooltip clicked!');
    if (this.trendChart && this.trendChart.hoverPoints && this.trendChart.hoverPoints.length > 0) {
      const point = this.trendChart.hoverPoints[0];
      console.log('Drilldown triggered from tooltip for timestamp:', point.x);
      this.switchToDrilldown(point.x);
    }
    
    // Prevent any issues with event propagation
    e.stopPropagation();
    return false;
  }
  
  protected inquiriesByTrend: any = {
    chart: {
      type: 'area',
      backgroundColor: '#FCFCFC',
      events: {
        load(e) {
          // Ensure 'this' correctly refers to the Highcharts instance
          const chart = e.target;

          // Prevent re-execution
          if (chart.hasLoaded) return;
          chart.hasLoaded = true;
          
          if (this.chart && this.chart.options.ngComponent) {
            this.chart.options.ngComponent.setChartExtremes();
          }
            setTimeout(() => {
      const contextBtn = chart?.exportSVGElements?.[0]?.element; // SVG group for context menu
      if (contextBtn) {
        contextBtn.addEventListener('click', () => {
          this.options.ngComponent.closeDropdownProgrammatically(this);
        });
      }
    }, 0);
          console.log('Chart loaded successfully');
        }
      }
    },
    title: {
      useHTML: true,
      text: '<span style="line-height: 21.79px;font-size: 16px;font-family: \'OpenSansBold\';color:\'#272727\'">Inquiries Trend</span>',
      align: 'left'
    },
    subtitle: {
      useHTML: true,
      text: '<div><span style="font-size:12px;font-family: \'OpenSans\'">Highest Inquiry Vol.</span> ' +
        '<span style="font-size:16px;color:#3EAD16;padding:0px 5px;font-family: \'OpenSansSemiBold\'" class="highestCount"></span>' +
        ' <span style="display:inline-block;width:1px;height:24px;background-color:#D8D9E5;margin:0 10px;vertical-align:middle;"></span><span style="font-size:12px;font-family: \'OpenSans\';color=#272727"><br class="d-block d-sm-none">Lowest Inquiry Vol.</span>' +
        '<span style="font-size:16px;color:#CF1010;padding:0px 5px;font-family: \'OpenSansSemiBold\'" ' +
        'class="lowestCount"></span></div>',
      align: 'left',
      verticalAlign: 'top',
      y: 50,
    },
    navigator: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    xAxis: [{
      labels: {
        style: {
          fontSize: '10px'
        }
      }
    }],
    yAxis: {
      min: 0,
      title: {
        text: null
      }
    },
    rangeSelector: {
      labelStyle: {
        display: 'none'
      },
      verticalAlign: 'top',
      buttonPosition: {
        align: 'center',
        x: 30,
        y: -65,
      },
      selected: 0,
      inputEnabled: false,
      buttons: [
        { type: 'week', count: 1, text: '1W' },
        { type: 'month', count: 1, text: '1M' },
        { type: 'month', count: 3, text: '1Q' },
        { type: 'year', count: 1, text: '1Y' }
      ],
      buttonTheme: {
        padding: 5,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#333',
        },
        states: {
          select: {
            fill: '#2B7DF8',
            style: {
              color: '#fff',
            }
          },
          hover: {
            fill: '#cddffa'
          }
        }
      }
    },
    tooltip: {
      holdDelay: 1500,
      useHTML: true,
      backgroundColor: 'rgba(252,252, 252,1)',
      formatter() {
        // Store reference to current point timestamp for click handler
        const timestamp = this.points[0].x;
        
        // Add a class to make it identifiable for click events
        setTimeout(() => {
          const tooltipEl = document.querySelector('.highcharts-tooltip');
          if (tooltipEl) {
            // tooltipEl.style.cursor = 'pointer';
            tooltipEl.classList.add('clickable-tooltip');
            tooltipEl.setAttribute('data-timestamp', timestamp);
            
            // Remove any existing event listeners to prevent duplicates
            tooltipEl.removeEventListener('click', InquiriesByTrendComponent.activeComponent.handleTooltipClick);
            
            // Add a new event listener
            tooltipEl.addEventListener('click', InquiriesByTrendComponent.activeComponent.handleTooltipClick);
          }
        }, 0);
        
        return [''].concat(
          this.points.map((point) => {
            return '<div style="color:{point.color};font-family:\'OpenSans\'">'
              + AppUtils.formatDate(new Date(point.x)) + '</div><div><b>&nbsp;' + point.y + '</b> inquiries</div>';
          })
        );
      }
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        marker: {
          enabled: true,
          radius: 4,
          symbol: 'circle',
          lineWidth: 1,
          states: {
            hover: {
              enabled: true,
              lineWidth: 2,
              radiusPlus: 2
            }
          }
        },
        point: {
          events: {
            click: function() {
              console.log('Direct point click detected on timestamp:', this.x);
              const component = this.series.chart.options.ngComponent;
              if (component) {
                component.switchToDrilldown(this.x);
                return false; // Prevent default without using preventDefault
              }
            }
          }
        }
      }
    },
    series: [{
      name: 'Inquiries Trend',
      data: null,
      threshold: null,
      lineColor: '#0BA1F6A0',
      lineWidth: 1,
      fillColor: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, '#97D1FF'],
          [1, '#0A97F800']
        ]
      },
      tooltip: {
        valueDecimals: 0,
        useHTML: true
      },
      opacity: 0.8,
      zIndex: 2
    }],
    navigation: {
      enabled: false,
      buttonOptions: {
        enabled: true,
        symbolSize: 25,
        symbolX: 18,
        symbolY: 28,
        theme: {
          r: 4,
        }
      }
    },
    exporting: {
      enabled: true,
      printMaxWidth: 1500,
      menuItemDefinitions: {
        maximize: {
          onclick() {
            if (this.options && this.options.ngComponent) {
              this.options.ngComponent.enterFullScreen(this);
            } else {
              console.log('Failed to enter full screen');
            }
          },
          text: 'Maximize'
        }
      },
      buttons: {
        contextButton: {
          menuItems: [{
            textKey: 'printChart',
            onclick() {
              this.print();
            }
          }, {
            textKey: 'downloadPNG',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend", "png");
              }
            }
          }, {
            textKey: 'downloadJPEG',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend", "jpg");
              }
            }
          }, {
            textKey: 'downloadPDF',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend", "pdf");
              }
            }
          }, {
            textKey: 'downloadCSV',
            onclick() {
              this.downloadCSV();
            }
          }, "maximize"],
          symbol: 'url(assets/dashboard/context-menu-right.png)'
        }
      },
      csv: {
        decimalPoint: ":"
      }
    },
    credits: {
      enabled: false
    },
    ngComponent: null,
    scrollbar: {
      barBackgroundColor: '#7E819B',
      barBorderColor: '#7E819B',
      barBorderRadius: 4,
      barBorderWidth: 0,
      buttonBackgroundColor: '#FCFCFC',
      buttonBorderColor: '#FCFCFC',
      buttonBorderWidth: 0,
      buttonArrowColor: '#FCFCFC',
      buttonBorderRadius: 7,
      rifleColor: '#7E819B',
      trackBackgroundColor: '#FCFCFC',
      trackBorderWidth: 1,
      trackBorderColor: '#D8D9E5',
      trackBorderRadius: 4,
      height: 8,
      enabled: true
    }
  };
  
  public drilldownOn = false;
  protected trendChart: any;
  protected chartData: any;
  protected drilldownDate: any;
  protected selectedDate: string = "";
  protected fullScreen = false;
  @ViewChild(FadingDialogComponent, { static: true }) fadingDialogComponent;
  protected minDate;
  protected maxDate;
  protected selectedGroup;
  selectedOption: string = 'inquiries';
  isNewResponse: boolean = false;
  availOptions = [
    { label: 'All', value: 'all' },
    { label: 'Inquiries', value: 'inquiries' },
    { label: 'Non-inquiries', value: 'noninquiries' }
  ];
  
  public inquiriesDrilldownColors = [
    '#D55FFF', '#EC4899', '#5C58C5', '#0BA1F6', '#15AB9B', '#F59E0B', '#F2CC00', '#6CC058', 
    '#15AB9B', '#E394FF', '#FE98DB', '#9592F7', '#2ECDFF', '#64DCCF', '#FFC461', '#FEED92', 
    '#9EEB8B', '#B316EB', '#EE0D7C', '#3D4376', '#0076B8', '#3EF4E1', '#2B9515', '#293DE2'
  ];

  public inquiriesDrillDownOptions: any = {
    chart: {
      type: 'column',
      backgroundColor: '#FCFCFC',
      height: 290
    },
    title: {
      useHTML: true,
      text: '<span style="line-height: 21.79px;font-size: 16px;font-family: \'OpenSansBold\';">Inquiries Timeline</span>',
      align: 'left',
      x: 24
    },
    subtitle: {
      useHTML: true,
      text: '<span class="innerLabel" style="font-family:\'OpenSans\';font-size:14px;">'
        + $('<div>').text(this.selectedDate).html() + '</span>',
      align: 'right',
      verticalAlign: 'top',
      x: 550,
      y: 10
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px;font-family:\'OpenSans\'">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0;font-family:\'OpenSans\'">{series.name}: </td>' +
        '<td style="padding:0;font-family:\'OpenSansBold\'"><b>{point.y:.0f} </b></td></tr>',
      footerFormat: '</table>',
      shared: false,
      useHTML: true
    },
    legend: {
      enabled: true
    },
    xAxis: {
      categories: ['8am to 12pm', '12pm to 4pm', '4pm to 8pm', 'other'],
      labels: {
        y: 20,
        style: {
          fontFamily: 'Open Sans'
        }
      },
      title: {
        style: {
          fontFamily: 'Open Sans'
        }
      }
    },
    yAxis: {
       reversed: false,
  min: 0,
  title: {
    text: 'Inquiries',
    style: {
      fontFamily: 'Open Sans'
    }
  },
  labels: {
    style: {
      fontFamily: 'Open Sans'
    }
  }
    },
    series: [],
    navigation: {
      enabled: false,
      buttonOptions: {
        enabled: true,
        symbolSize: 28,
        symbolX: 21,
        symbolY: 28
      }
    },
    exporting: {
      // C153176-4479: support larger print max width
      printMaxWidth: 1500,
      menuItemDefinitions: {
        maximize: {
          onclick() {
            if (this.options && this.options.ngComponent) {
              this.options.ngComponent.enterFullScreen(this);
            } else {
              console.log('Failed to enter full screen');
            }
          },
          text: 'Maximize'
        }
      },
      buttons: {
        contextButton: {
          menuItems: [{
            textKey: 'printChart',
            onclick() {
              this.print();
            }
          }, {
            textKey: 'downloadPNG',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend-drilldown", "jpg");
              }
            }
          }, {
            textKey: 'downloadJPEG',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend-drilldown", "jpg");
              }
            }
          }, {
            textKey: 'downloadPDF',
            onclick: function() {
              if (this.options && this.options.ngComponent) {
                this.options.ngComponent.localService.download("inquiries-by-trend-drilldown", "pdf");
              }
            }
          }, {
            textKey: 'downloadCSV',
            onclick() {
              this.downloadCSV();
            }
          }, "maximize"],
          symbol: 'url(assets/dashboard/context-menu-right.png)'
        }
      },
      csv: {
        decimalPoint: ":"
      }
    },
    credits: {
      enabled: false
    },
    ngComponent: null
  };
  
  drilldownChart: any;

  ngOnInit() {
    // Store reference to active component for static tooltip handler
    InquiriesByTrendComponent.activeComponent = this;
    
    if (this.trendData) {
      if (this.handleTrends(JSON.stringify(this.trendData))) {
        // Re-apply Highcharts modules to ensure they're available
        applyHighchartsModule(Exporting, Highcharts);
        applyHighchartsModule(OfflineExporting, Highcharts);
        applyHighchartsModule(ExportData, Highcharts);
        applyHighchartsModule(StockModule, Highcharts);
        
        // Use a slightly longer timeout to ensure DOM is ready
        setTimeout(() => {
          const elem = $('#inquiries-by-trend');
          if (elem && elem.length) {
            Highcharts.setOptions({ lang: { thousandsSep: "," } });
            
            // Destroy existing chart if it exists to prevent memory leaks
            if (this.trendChart && typeof this.trendChart.destroy === 'function') {
              try {
                this.trendChart.destroy();
              } catch (e) {
                console.warn('Error destroying existing chart', e);
              }
            }
            
            this.trendChart = Highcharts.stockChart('inquiries-by-trend', this.inquiriesByTrend);
            this.trendChart.options.ngComponent = this;
            this.setChartExtremes();
          }
        }, 0);
      } else {
        console.log("Invalid or empty trend data");
      }

      this.dashboardService.getInquiriesTimeline.subscribe(data => {
        if (this.trendChart) {
          // Show the loading label
          this.trendChart.showLoading('Loading drilldown data...');
          const myChart = this.trendChart;
          const me = this;
          const series = this.generateTimelineSeries(data);
          if (series) {
            this.showDrilldownChart(series);
          } else {
            console.log('skipping showing drilldown due to empty data');
          }
          this.trendChart.hideLoading();
        }
      });
      
      this.localService.getSelectedGroupName.subscribe(groupName => {
        // C153176-5105: check whether the requested group was already requested previously. If so, skip the request.
        let selectedGroup = "All";
        if (groupName !== "") {
          selectedGroup = groupName;
        }
        if (this.selectedGroup === selectedGroup) {
          // the group data was just requested, skip requesting again.
          return;
        }
        this.selectedGroup = selectedGroup;
        // this.dashboardService.getInquiriesTrendCnts(this.selectedGroup);
      });
    }
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['trendData']) {
      this.ngOnInit();
    }
  }
  
  /**
   * Handle request type counts by group
   * @param jsonData jSON response from service call
   */
  private handleTrends(jsonData: string): boolean {
    if (!jsonData) {
      return false;
    }
    try {
      /* C153176-5430:To add filter for Inquiries and non inquiries */
      let chartJson: Object = JSON.parse(jsonData);
      if (chartJson.hasOwnProperty('inquiries')) {
        this.isNewResponse = true;
        let inquiriesTrends = chartJson[this.selectedOption];
        const inquiryTrend = inquiriesTrends.map((elem) => {
          return { date: elem.date, inquiryCount: elem.count };
        });
        inquiryTrend.reverse();
        this.chartData = inquiryTrend;
      }
      else {
        this.chartData = chartJson;
      }
    } catch (error) { }
    return this.updateChart(true);
  }

  protected updateChart(updateData: boolean): boolean {
    if (!this.chartData || !this.chartData.length) {
      return false;
    }
    const data = this.chartData;
    // get the highest count entry
    const highestCount = data.reduce((prev, cur) =>
      prev && prev.inquiryCount > cur.inquiryCount ? prev : cur);
    // get the lowest count entry
    const lowestCount = data.reduce((prev, cur) =>
      prev && prev.inquiryCount < cur.inquiryCount ? prev : cur);

    const tempDom = $.parseHTML(this.inquiriesByTrend.subtitle.text);
    $('.highestCount', tempDom).text((highestCount ? highestCount.inquiryCount : 0));
    $('.lowestCount', tempDom).text((lowestCount ? lowestCount.inquiryCount : 0));

    this.inquiriesByTrend.subtitle.text = $(tempDom).prop('outerHTML');
    
    // Transform and prepare data for chart
    this.inquiriesByTrend.series[0].data = data.map((p) => {
      const time = new Date(p.date).getTime();
      this.minDate = (!this.minDate || this.minDate > time) ? time : this.minDate;
      this.maxDate = (!this.maxDate || this.maxDate < time) ? time : this.maxDate;
      return [time, p.inquiryCount];
    });
    return true;
  }

  switchToDrilldown(timestamp) {
    console.log('Switching to drilldown for timestamp:', timestamp);
    this.drilldownOn = true;
    const date = AppUtils.formatDate(new Date(timestamp));
    this.drilldownDate = date;
    this.selectedDate = AppUtils.formatDate(new Date(timestamp), true).substring(4);
    
    // Add a brief timeout to hide any tooltip that might be visible
    setTimeout(() => {
      if (this.trendChart) {
        this.trendChart.tooltip.hide();
      }
      this.getDrilldownEvent(timestamp);
    }, 10);
  }

  getDrilldownEvent(date) {
    console.log('Getting drilldown data for date:', date);
    this.dashboardService.getInquiriesTimelineCnts(date, this.selectedGroup, this.selectedOption);
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Inquiries Trend Click on line graph", "Click", "Inquiries Trend Click on line graph", 1);
  }

  generateTimelineSeries(data) {
    const date = this.drilldownDate ? this.drilldownDate : data.date;
    const categorySet = new Set();
    const groupMap = {};
    for (const t in data) {
      if (t === 'date') {
        continue;
      }
      categorySet.add(t);
      const sub = data[t];
      if (sub) {
        for (const g of Object.keys(sub)) {
          const v = sub[g];
          if (!groupMap[g]) {
            groupMap[g] = {};
          }
          if (!groupMap[g][t]) {
            groupMap[g][t] = v;
          }
        }
      }
    }
    const categories = Array.from(categorySet).sort((a: string, b: string) => {
      if (a.toLowerCase().includes("am") && b.toLowerCase().includes("pm")) {
        return -1;
      } else if (a.toLowerCase().includes("pm") && b.toLowerCase().includes("am")) {
        return 1;
      } else if ((a.toLowerCase().includes("pm") && b.toLowerCase().includes("pm")) ||
        (a.toLowerCase().includes("am") && b.toLowerCase().includes("am"))) {
        if (a[0] < b[0]) {
          return -1;
        } else if (a[0] === b[0]) {
          return 0;
        } else {
          return 1;
        }
      } else {
        if (a.toLowerCase().includes('other') && !b.toLowerCase().includes('other')) {
          return 1;
        } else if (!a.toLowerCase().includes('other') && b.toLowerCase().includes('other')) {
          return -1;
        } else {
          const taIndex = a.toLowerCase().indexOf('to');
          const tbIndex = b.toLowerCase().indexOf('to');
          const ta = taIndex !== -1 ? a.substring(0, taIndex) : a;
          const tb = tbIndex !== -1 ? b.substring(0, tbIndex) : b;
          if (parseInt(ta) === 4 && parseInt(ta) !== parseInt(b)) {
            return 1;
          } else {
            if (ta.length < tb.length) {
              return -1;
            } else if (parseInt(ta) < parseInt(tb)) {
              return -1;
            } else if (parseInt(ta) === parseInt(tb)) {
              return 0;
            } else {
              return 1;
            }
          }
        }
      }
    });

    let groups = Object.keys(groupMap).sort();
    groups = groups.sort((a, b) => {
      if (a.includes('lte') && !b.includes('lte')) {
        return -1;
      } else if (!a.includes('lte') && b.includes('lte')) {
        return 1;
      } else {
        const na = parseInt(a.slice(2));
        const nb = parseInt(b.slice(2));
        if (na < nb) {
          return -1;
        } else if (na === nb) {
          return 0;
        } else {
          return 1;
        }
      }
    });
    const series = [];
    groups.forEach((g, index) => {
      const subs = [];
      const timelines = groupMap[g];
      categories.forEach((t) => {
        const subV = [];
        const c = timelines[t];
        subV.push(this.convertTimeLineLabel(t));
        subV.push(c);
        subs.push(subV);
      });
      const convertedGroup = this.convertGroupLabel(g);
      series.push({ id: convertedGroup, name: convertedGroup, data: subs, color: this.inquiriesDrilldownColors[index] });
    });
    this.inquiriesByTrend.xAxis[0].labels.drilldown = categories.map(e => this.convertTimeLineLabel(e));
    return series;
  }

  convertGroupLabel(g) {
    if (!g) {
      return g;
    }
    if (g.includes('0to1')) {
      return '0-1 Days';
    } else if (g.includes('2to5')) {
      return '2-5 Days';
    } else if (g.includes('6to15')) {
      return '6-15 Days';
    } else if (g.includes('gt16')) {
      return '16+ Days';
    } else {
      return g;
    }
  }

  convertTimeLineLabel(t) {
    if (!t) {
      return t;
    }
    if (t.includes('8am')) {
      return '8am to 12pm';
    } else if (t.includes('12pm')) {
      return '12pm to 4pm';
    } else if (t.includes('4pm')) {
      return '4pm to 8pm';
    } else if (t.includes('4to8')) {
      return '4pm to 8pm';
    } else if (t.includes('8to12')) {
      return '8am to 12pm';
    } else if (t.includes('12to4')) {
      return '12pm to 4pm';
    } else {
      return t;
    }
  }

  showDrilldownChart(dSeries) {
    if (dSeries.length) {
      this.inquiriesDrillDownOptions.subtitle.text = '<span class="innerLabel" style="font-family:\'OpenSans\';font-size:14px;">'
        + $('<div>').text(this.selectedDate).html() + '</span>';
      this.inquiriesDrillDownOptions.subtitle.align = 'left';
      this.inquiriesDrillDownOptions.subtitle.verticalAlign = 'top';
      this.inquiriesDrillDownOptions.subtitle.x = 550;
      this.inquiriesDrillDownOptions.subtitle.y = 10;
    } else {
      this.inquiriesDrillDownOptions.subtitle.text = '<span class="innerLabel" style="font-family:\'OpenSans\';font-size:16px;">'
        + $('<div>').text('No timeline data available on ' + this.selectedDate + '.').html() + '</span>';
      this.inquiriesDrillDownOptions.subtitle.align = 'center';
      this.inquiriesDrillDownOptions.subtitle.verticalAlign = 'center';
      this.inquiriesDrillDownOptions.subtitle.x = undefined;
      this.inquiriesDrillDownOptions.subtitle.y = 100;
    }

    this.inquiriesDrillDownOptions.series = dSeries;
    const elem = $('#inquiries-by-trend-drilldown');
    if (elem && elem.length) {

      if (this.drilldownChart && typeof this.drilldownChart.destroy === 'function') {
        try {
          // Check if chart is still valid
          if (this.drilldownChart.renderTo && this.drilldownChart.container) {
            this.drilldownChart.destroy();
          } else {
            // If chart is invalid, just set it to null without destroying
            this.drilldownChart = null;
          }
        } catch (e) {
          console.warn('Error while destroying request type chart', e);
          // Ensure drilldownChart is nullified even if destroy fails
          this.drilldownChart = null;
        }
      }
      this.drilldownChart = Highcharts.chart('inquiries-by-trend-drilldown', this.inquiriesDrillDownOptions);
      if (this.drilldownChart) {
        const component = this;
        this.drilldownChart.renderer.image("./assets/qwyn/icons/left-arrow.svg", 15, 12, 12, 12).attr({
          zIndex: 3
        }).on('click', () => {
          component.switchToTrendChart();
        }).add();

      }
      this.drilldownChart.options.ngComponent = this;
    }
  }

  switchToTrendChart() {
    this.drilldownOn = false;
  }

  // handle ESC in case of full screen
  @HostListener('document:keydown.esc', ['$event'])
  onKeydown(event) {
    // Don't use stopPropagation or preventDefault here to avoid passive listener issues
    if (this.fullScreen && event && event.code === 'Escape') {
      this.exitFullScreen(this.trendChart);
    }
  }

  enterFullScreen(chart: any) {
    const elem = $('#trend-chart-box');
    if (elem && elem.length) {
      elem.toggleClass('col-sm-6');
      elem.toggleClass('dashboardModal');
    }
    this.fullScreen = true;
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = 'none';
            }
          });
        }
      });
    }
    chart.reflow();
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.show($('#inquiries-by-trend-box')[0]);
    }
  }

  exitFullScreen(chart: any) {
    if (!chart) {
      return;
    }
    const elem = $('#trend-chart-box');
    if (elem && elem.length) {
      elem.toggleClass('col-sm-6');
      elem.toggleClass('dashboardModal');
    }
    this.fullScreen = false;
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.hide($('#inquiries-by-trend-box')[0]);
    }
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = '';
            }
          });
        }
      });
    }
    chart.reflow();
  }

  setChartExtremes() {
    /*
    if (this.trendChart && this.minDate && this.maxDate) {
      let delta = Math.floor((this.maxDate - this.minDate) / 10);
      let endDate = this.minDate + delta;
      this.trendChart.xAxis[0].setExtremes(this.minDate.valueOf(), endDate.valueOf());
    }
    */
  }

  onOptSelection(evt: any) {
    console.log(evt);
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Inquiries Trend -Inquiry Type Filter- switch to " + evt.value, "Click", "Inquiries Trend -Inquiry Type Filter- switch to " + evt.value, 0);
    this.selectedOption = evt.value;
    this.ngOnInit();
  }
}